import request from './request'

export function listMaintenanceOrder(data) {
  return request.post('/mes/maintenance-orders/list', data)
}
export function getMaintenanceOrder(id) {
  return request.get('/mes/maintenance-orders/' + id)
}
export function saveMaintenanceOrder(data) {
  return request.post('/mes/maintenance-orders', data)
}
export function updateMaintenanceOrder(data) {
  return request.post('/mes/maintenance-orders/update', data)
}
export function deleteMaintenanceOrder(ids) {
  return request.post('/mes/maintenance-orders/delete', ids)
}
export function startMaintenanceOrder(moId) {
  return request.post('/mes/maintenance-orders/start', { moId })
}
export function finishMaintenanceOrder(moId, solution) {
  return request.post('/mes/maintenance-orders/finish', { moId, solution })
}
export function cancelMaintenanceOrder(moId) {
  return request.post('/mes/maintenance-orders/cancel', { moId })
}
